import {
  createRouter,
  createWebHashHistory,
} from 'vue-router';

import uploadxls2 from '../components/uploadxls2.vue';
import HomeView from '../views/HomeView2.vue';
import TenderEntityH5 from '../views/TenderEntityH5.vue';
import uploadfile2 from '../views/uploadfile2.vue';
import uploadFileView from '../views/uploadFileView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/uploadFileView',
    name: 'uploadFileView',
    component: uploadFileView
  },
  {
    path: '/TenderEntityH5',
    name: 'TenderEntityH5',
    component: TenderEntityH5
  },
    {
    path: '/uploadxls2',
    name: 'uploadxls2',
    component: uploadxls2
  },
   {
    path: '/uploadfile2',
    name: 'uploadfile2',
    component: uploadfile2
  },
  {
    //当所有的路由都匹配不到的时候,跳转404页面
    path: '/:pathMatch(.*)*',
    redirect: '/404',
    name: 'Any',
  }
 
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
